import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import Header from './component/Header';
import Banner from './component/Banner';
import Footer from './component/Footer';
import Intro from './component/Intro';
import Business from './component/Business';
import Popup from './component/Popup';
import Collaborative from './component/Collaborative';
import Objective from './component/Objective';
import VideoBanner from './component/VideoBanner';
import Objective2 from './component/Objective2';

const App: React.FC = () => {
    const [showIntro, setShowIntro] = useState(false);
    const [showObjective, setShowObjective] = useState(false);
    const [showBusiness, setShowBusiness] = useState(false);
    const [showBusinessWait, setShowBusinessWait] = useState(false);
    const [showCollaborative, setShowCollaborative] = useState(false);
    const [showObjective2, setShowObjective2] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const introRef = useRef<HTMLDivElement>(null);
    const objectiveRef = useRef<HTMLDivElement>(null);
    const objective2Ref = useRef<HTMLDivElement>(null);
    const businessRef = useRef<HTMLDivElement>(null);
    const collaborativeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.target === introRef.current && entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        setShowIntro(true);
                    }
                    if (
                        entry.target === objectiveRef.current &&
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.5
                    ) {
                        setShowObjective(true);
                    }
                    if (
                        entry.target === objective2Ref.current &&
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.5
                    ) {
                        setShowObjective2(true);
                    }
                    if (
                        entry.target === businessRef.current &&
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.5
                    ) {
                        setShowBusiness(true);
                        setTimeout(() => {
                            setShowBusinessWait(true);
                        }, 800);
                    }
                    if (
                        entry.target === collaborativeRef.current &&
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.5
                    ) {
                        setShowCollaborative(true);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (introRef.current) {
            observer.observe(introRef.current);
        }
        if (objectiveRef.current) {
            observer.observe(objectiveRef.current);
        }
        if (objective2Ref.current) {
            observer.observe(objective2Ref.current);
        }
        if (businessRef.current) {
            observer.observe(businessRef.current);
        }
        if (collaborativeRef.current) {
            observer.observe(collaborativeRef.current);
        }

        return () => {
            if (introRef.current) {
                observer.unobserve(introRef.current);
            }
            if (objectiveRef.current) {
                observer.unobserve(objectiveRef.current);
            }
            if (objective2Ref.current) {
                observer.unobserve(objective2Ref.current);
            }
            if (businessRef.current) {
                observer.unobserve(businessRef.current);
            }
            if (collaborativeRef.current) {
                observer.unobserve(collaborativeRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setShowScrollToTop(true);
            } else {
                setShowScrollToTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // 홈페이지 첫 접속 시 팝업 표시
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 1000); // 1초 후에 팝업 표시

        return () => clearTimeout(timer);
    }, []);

    const scrollToIntro = () => {
        if (introRef.current) {
            introRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const openPopup = () => {
        setShowPopup(true);
    };
    const closePopup = () => {
        setShowPopup(false);
    };
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <>
            <Header onAboutClick={scrollToIntro}></Header>
            <VideoBanner></VideoBanner>
            <div ref={introRef} className={`intro-container ${showIntro ? 'visible' : ''}`}>
                <Intro></Intro>
            </div>
            <div ref={objectiveRef} className={`objective-container ${showObjective ? 'visible' : ''}`}>
                <Objective></Objective>
            </div>
            <div ref={objective2Ref} className={`objective2-container ${showObjective2 ? 'visible' : ''}`}>
                {showObjective2 && <Objective2></Objective2>}
            </div>
            <div ref={businessRef} className={`business-container ${showBusinessWait ? 'visible' : ''}`}>
                {showBusiness && <Business></Business>}
            </div>
            <div ref={collaborativeRef} className={`collaborative-container ${showCollaborative ? 'visible' : ''}`}>
                <Collaborative></Collaborative>
            </div>
            <div className={`popup-container ${showPopup ? 'visible' : ''}`}>
                <Popup onClose={closePopup}></Popup>
            </div>
            <Footer></Footer>
            {showScrollToTop && (
                <button className="scroll-to-top" onClick={scrollToTop}>
                    ▲
                </button>
            )}
        </>
    );
};

export default App;
